import React from 'react';
import { Badge } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { TabErrorBadgeProps } from './types';
import './TabErrorBadge.scss';

export const TabErrorBadge: React.FC<TabErrorBadgeProps> = ({ errorCount }) => {
  // Don't show badge if no errors
  if (errorCount === 0) {
    return null;
  }

  return (
    <Badge
      badgeContent={<ErrorOutlineIcon sx={{ fontSize: 14 }} />}
      className="tabErrorBadge"
      color="error"
    />
  );
};
